import React, { useContext, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
// import { useNavigate, Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import Container from "@mui/material/Container";
import Layout from "./Layout";

const Terms = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const lastUpdate = "2024-11-13";
  const contactEmail = "info@qrdoor.click";
  const country = "Argentina";

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState(
        [
          { label: intl.formatMessage({ id: "app.header.home.label" }), url: "/" },
          { label: intl.formatMessage({ id: "app.header.help.label" }), url: "/help" },
        ]
      );
    }
  }, []);

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          {/* Title */}
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage id="app.terms.title" />
            </Typography>
          </Grid>
          {/* Last Update */}
          <Grid item xs={12}>
            <Typography variant="body2">
              <FormattedMessage id="app.terms.lastUpdate" values={{lastUpdate:lastUpdate}} />
            </Typography>
          </Grid>
          {/* Introduction */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.introduction" />
            </Typography>
          </Grid>
          {/* Service Description */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.serviceDescription.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.serviceDescription.text" />
            </Typography>
          </Grid>
          {/* Disclaimer */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.disclaimer.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.disclaimer.noWarranty" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.disclaimer.malfunction" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.disclaimer.limitation" />
            </Typography>
          </Grid>
          {/* Permitted Use */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.allowedUse.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.allowedUse.text" />
            </Typography>
          </Grid>
          {/* Personal Data Protection */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.dataProtection.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.dataProtection.text" />
            </Typography>
          </Grid>
          {/* Service and Terms Modification */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.modification.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.modification.text" />
            </Typography>
          </Grid>
          {/* Governing Law and Jurisdiction */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.governingLaw.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.governingLaw.text" values={{country:country}} />
            </Typography>
          </Grid>
          {/* Contact */}
          <Grid item xs={12}>
            <Typography variant="h6">
              <FormattedMessage id="app.terms.contact.title" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="app.terms.contact.text" values={{contactEmail:contactEmail}} />
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Terms;
